<div class="flex flex-col border border-gray-300 rounded-xl overflow-hidden bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 transition-shadow">
  <!-- Toolbar -->
  <div class="flex flex-wrap items-center gap-0.5 bg-gray-50 border-b border-gray-200 p-1.5 shrink-0 select-none" *ngIf="!readonly">
    <button type="button" (mousedown)="$event.preventDefault(); format('bold')" title="Bold (Ctrl+B)" class="p-1.5 text-gray-500 hover:bg-gray-200 hover:text-gray-800 rounded transition cursor-pointer">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6z M6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z"/>
      </svg>
    </button>
    <button type="button" (mousedown)="$event.preventDefault(); format('italic')" title="Italic (Ctrl+I)" class="p-1.5 text-gray-500 hover:bg-gray-200 hover:text-gray-800 rounded transition cursor-pointer">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l-4 12"/>
      </svg>
    </button>
    <button type="button" (mousedown)="$event.preventDefault(); format('underline')" title="Underline (Ctrl+U)" class="p-1.5 text-gray-500 hover:bg-gray-200 hover:text-gray-800 rounded transition cursor-pointer">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 5v7a8 8 0 0016 0V5M4 19h16"/>
      </svg>
    </button>
    <div class="w-px h-5 bg-gray-300 mx-1"></div>
    <button type="button" (mousedown)="$event.preventDefault(); format('insertUnorderedList')" title="Bullet List" class="p-1.5 text-gray-500 hover:bg-gray-200 hover:text-gray-800 rounded transition cursor-pointer">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16M4 6h.01M4 12h.01M4 18h.01"/>
      </svg>
    </button>
    <button type="button" (mousedown)="$event.preventDefault(); format('insertOrderedList')" title="Numbered List" class="p-1.5 text-gray-500 hover:bg-gray-200 hover:text-gray-800 rounded transition cursor-pointer">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M7 6h14M7 12h14M7 18h14M3 6h.01M3 12h.01M3 18h.01"/>
      </svg>
    </button>
    <div class="w-px h-5 bg-gray-300 mx-1"></div>
    <button type="button" (mousedown)="$event.preventDefault(); link()" title="Insert Link" class="p-1.5 text-gray-500 hover:bg-gray-200 hover:text-gray-800 rounded transition cursor-pointer">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13.828 10.172a4 4 0 010 5.656l-3 3a4 4 0 01-5.656-5.656l1.5-1.5m4.5-4.5l1.5-1.5a4 4 0 015.656 5.656l-3 3a4 4 0 01-5.656 0"/>
      </svg>
    </button>
    <button type="button" (mousedown)="$event.preventDefault(); format('removeFormat')" title="Clear Formatting" class="p-1.5 text-gray-500 hover:bg-gray-200 hover:text-gray-800 rounded transition cursor-pointer">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
      </svg>
    </button>
  </div>

  <!-- Editable area -->
  <div
    #editor
    contenteditable="true"
    [attr.placeholder]="placeholder"
    [class]="heightClass + ' px-3.5 py-2.5 outline-none text-sm text-gray-700 bg-transparent overflow-y-auto rich-editor-content'"
    (input)="onInput()"
    (blur)="onBlur()"
    (paste)="onPaste($event)"
    (keydown)="onKeyDown($event)">
  </div>
</div>
